import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import moment from "moment";
import ctCountyOptions from "../../../_helpers/ctCountyCodes";
import projActions from "../../../_actions/projActions";
import AlertModal from "../../_common/AlertModal";
import CustomDatePickerInput from "../../_common/CustomDatePickerInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class EditProjectModal extends Component {
  state = {
    newProjId: null,
    formData: {
      createdByUserId: 0,
      createdOn: new Date(),
      district: "",
      selectedDistrict: null,
      ea: "",
      efis: "",
      fedId: "",
      counties: "",
      county1: "",
      county2: "",
      county3: "",
      county4: "",
      selectedCounty1: null,
      selectedCounty2: null,
      selectedCounty3: null,
      selectedCounty4: null,
      route1: "",
      route2: "",
      route3: "",
      route4: "",
      backPostMile1: "",
      aheadPostMile1: "",
      backPostMile2: "",
      aheadPostMile2: "",
      backPostMile3: "",
      aheadPostMile3: "",
      backPostMile4: "",
      aheadPostMile4: "",
      calendarType: "5d",
      selectedCalendarType: { value: "5d", label: "5-day" },
      workingDays: "",
      bidOpeningDate: new Date(),
      contractAwardDate: new Date(),
      contractApprovalDate: new Date(),
      firstWorkingDay: new Date(),
      engineersEstimate: "",
      workDescription: "",
      locationDescription: "",
      useTroMarkup: false,
      primeLaborMarkup: "",
      primeEquipmentMarkup: "",
      primeMaterialMarkup: "",
      subcontractorMarkup: "",
      subLaborMarkup: "",
      subEquipmentMarkup: "",
      subMaterialMarkup: "",
      isNew: true,
      projectStatus: "",
      selectedProjectStatus: null,
    },
    formErrors: {
      district: null,
      ea: null,
      county1: null,
      route1: null,
      backPostMile1: null,
      aheadPostMile1: null,
      workDescription: null,
      primeLaborMarkup: null,
      primeEquipmentMarkup: null,
      primeMaterialMarkup: null,
      subcontractorMarkup: null,
      subLaborMarkup: null,
      subEquipmentMarkup: null,
      subMaterialMarkup: null,
    },
    showAlert_editSuccess: false,
    showAlert_cancel: false,
  };

  // Build selector options
  projDistOptions = [
    { value: 1, label: "01" },
    { value: 2, label: "02" },
    { value: 3, label: "03" },
    { value: 4, label: "04" },
    { value: 5, label: "05" },
    { value: 6, label: "06" },
    { value: 7, label: "07" },
    { value: 8, label: "08" },
    { value: 9, label: "09" },
    { value: 10, label: "10" },
    { value: 11, label: "11" },
    { value: 12, label: "12" },
  ];
  projStatusOptions = [
    { value: "ADVERTISED", label: "Advertised" },
    { value: "PRE_CONST", label: "Pre-Const" },
    { value: "IN_CONST", label: "In-Const" },
    { value: "POST_CONST", label: "Post-Const" },
  ];
  calendarTypes = [
    { value: "5d", label: "5-day" },
    { value: "7d", label: "7-day" },
  ];
  countyOptions = [...ctCountyOptions, { value: "Var", label: "Var - Various" }];

  componentDidMount() {
    const { isNewProject, project } = this.props;
    if (!isNewProject) {
      const formData = {
        createdByUserId: project.createdByUserId,
        createdOn: new Date(project.createdOn),
        district: project.district,
        selectedDistrict: this.projDistOptions.find((o) => o.value === project.district),
        ea: project.ea,
        efis: project.efis,
        fedId: project.fedId,
        county1: project.county1,
        selectedCounty1:
          (project.county1 &&
            this.countyOptions.find(
              (c) => c.value.toLowerCase() === project.county1.toLowerCase()
            )) ||
          null,
        route1: project.route1,
        backPostMile1: project.backPostMile1,
        aheadPostMile1: project.aheadPostMile1,
        county2: project.county2,
        selectedCounty2:
          (project.county2 &&
            this.countyOptions.find(
              (c) => c.value.toLowerCase() === project.county2.toLowerCase()
            )) ||
          null,
        route2: project.route2,
        backPostMile2: project.backPostMile2,
        aheadPostMile2: project.aheadPostMile2,
        county3: project.county3,
        selectedCounty3:
          (project.county3 &&
            this.countyOptions.find(
              (c) => c.value.toLowerCase() === project.county3.toLowerCase()
            )) ||
          null,
        route3: project.route3,
        backPostMile3: project.backPostMile3,
        aheadPostMile3: project.aheadPostMile3,
        county4: project.county4,
        selectedCounty4:
          (project.county4 &&
            this.countyOptions.find(
              (c) => c.value.toLowerCase() === project.county4.toLowerCase()
            )) ||
          null,
        route4: project.route4,
        backPostMile4: project.backPostMile4,
        aheadPostMile4: project.aheadPostMile4,
        calendarType: project.calendarType || "5d",
        selectedCalendarType: project.calendarType === "7d"
          ? { value: "7d", label: "7-day" }
          : { value: "5d", label: "5-day" },
        workingDays: project.workingDays,
        bidOpeningDate: new Date(project.bidOpeningDate),
        contractAwardDate: new Date(project.contractAwardDate),
        contractApprovalDate: new Date(project.contractApprovalDate),
        firstWorkingDay: new Date(project.firstWorkingDay),
        engineersEstimate: project.engineersEstimate,
        workDescription: project.workDescription,
        locationDescription: project.locationDescription,
        projectStatus: project.projectStatus,
        // selectedProjectStatus: this.projStatusOptions.find(
        //   (o) => o.value === project.projectStatus
        // ),
        useTroMarkup: project.useTroMarkup,
        primeLaborMarkup: project.primeLaborMarkup,
        primeEquipmentMarkup: project.primeEquipmentMarkup,
        primeMaterialMarkup: project.primeMaterialMarkup,
        subcontractorMarkup: project.subcontractorMarkup,
        subLaborMarkup: project.subLaborMarkup,
        subEquipmentMarkup: project.subEquipmentMarkup,
        subMaterialMarkup: project.subMaterialMarkup,
      };
      this.setState({ formData });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    const formData = { ...this.state.formData };
    formData[name] = value;
    this.setState({ formData });
  };

  handleChange_check = (e) => {
    const formData = { ...this.state.formData };
    formData[e.target.name] = e.target.checked;
    this.setState({ formData });
  };

  handleChange_select = (fieldName, optionFieldName) => (selectedOption) => {
    const formData = { ...this.state.formData };
    formData[fieldName] = selectedOption ? selectedOption.value : null;
    formData[optionFieldName] = selectedOption;
    this.setState({ formData }, () => this.validateForm(fieldName));
  };

  handleChange_dateFields = (fieldName) => (value) => {
    const formData = { ...this.state.formData };
    formData[fieldName] = value;
    this.setState({ formData });
  };

  handleBlur = (e) => this.validateForm(e.target.name);
  handleBlur_select = (fieldName) => () => this.validateForm(fieldName);

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "district":
        if (!formData.selectedDistrict) formErrors.district = "Required";
        else formErrors.district = null;
        break;
      case "ea":
        if (!formData.ea) formErrors.ea = "EA is required";
        else formErrors.ea = null;
        break;
      case "county1":
        if (!formData.selectedCounty1) formErrors.county1 = "Required (can be 'Var')";
        else formErrors.county1 = null;
        break;
      case "route1":
        if (!formData.route1) formErrors.route1 = "Required (can be 'Var')";
        else formErrors.route1 = null;
        break;
      case "backPostMile1":
        formErrors.backPostMile1 = formData.backPostMile1 == null || formData.backPostMile1 === "" ? "Required" : null;
        break;
      case "aheadPostMile1":
        formErrors.aheadPostMile1 = formData.aheadPostMile1 == null || formData.aheadPostMile1 === "" ? "Required" : null;
        break;
      case "workDescription":
        if (!formData.workDescription)
          formErrors.workDescription = "Work description is required";
        else formErrors.workDescription = null;
        break;
      case "primeLaborMarkup":
      case "primeEquipmentMarkup":
      case "primeMaterialMarkup":
      case "subcontractorMarkup":
      case "subLaborMarkup":
      case "subEquipmentMarkup":
      case "subMaterialMarkup":
        if (formData[fieldName] > 100) formErrors[fieldName] = "Invalid value";
        else formErrors[fieldName] = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const {
      district,
      ea,
      county1,
      route1,
      backPostMile1,
      aheadPostMile1,
      workDescription,
      primeLaborMarkup,
      primeEquipmentMarkup,
      primeMaterialMarkup,
      subcontractorMarkup,
      subLaborMarkup,
      subEquipmentMarkup,
      subMaterialMarkup,
    } = this.state.formErrors;
    const { formData } = this.state;
    return (
      district ||
      ea ||
      county1 ||
      route1 ||
      backPostMile1 ||
      aheadPostMile1 ||
      workDescription ||
      primeLaborMarkup ||
      primeEquipmentMarkup ||
      primeMaterialMarkup ||
      subcontractorMarkup ||
      subLaborMarkup ||
      subEquipmentMarkup ||
      subMaterialMarkup ||
      !formData.ea ||
      !formData.county1 ||
      !formData.route1 ||
      (formData.backPostMile1 == null || formData.backPostMile1 === "") ||
      (formData.aheadPostMile1 == null || formData.aheadPostMile1 === "") ||
      !formData.workDescription
    );
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const formData = { ...this.state.formData };
    const { dispatch, authentication, isNewProject, project, refreshProjList } =
      this.props;
    const formatDate = (date) => moment(date).format();
    if (!this.formIsIncomplete()) {
      formData.bidOpeningDate = formData.bidOpeningDate
        ? formatDate(formData.bidOpeningDate)
        : null;
      formData.contractAwardDate = formData.contractAwardDate
        ? formatDate(formData.contractAwardDate)
        : null;
      formData.contractApprovalDate = formData.contractApprovalDate
        ? formatDate(formData.contractApprovalDate)
        : null;
      formData.firstWorkingDay = formData.firstWorkingDay
        ? formatDate(formData.firstWorkingDay)
        : null;
      formData.createdOn = formData.createdOn ? formatDate(formData.createdOn) : null;
      formData.createdByUserId = isNewProject ? authentication.user.userId : null;

      if (isNewProject) {
        dispatch(projActions.add(formData)).then((newProjId) => {
          this.setState({ newProjId });
          refreshProjList(false);
          this.toggleAlert_editSuccess();
        });
      } else {
        formData.projectId = project.projectId;
        dispatch(projActions.update(formData)).then(() => {
          refreshProjList(false);
          this.toggleAlert_editSuccess();
        });
      }
    }
  };

  handleClick_cancel = (e) => {
    e.preventDefault();
    this.toggleAlert_cancel();
  };
  toggleAlert_cancel = () =>
    this.setState({ showAlert_cancel: !this.state.showAlert_cancel });
  toggleAlert_editSuccess = () =>
    this.setState({ showAlert_editSuccess: !this.state.showAlert_editSuccess });

  handleAlert_cancel = (actionType) => (e) => {
    e.preventDefault();
    this.toggleAlert_cancel();
    if (actionType === "accept") this.props.toggleEditProjectModal();
  };

  handleAlert_addSuccess = (actionType) => (e) => {
    e.preventDefault();
    this.toggleAlert_editSuccess();
    if (actionType === "accept") this.props.toggleEditProjectModal();
  };

  render() {
    const { formData, formErrors, showAlert_cancel, showAlert_editSuccess } = this.state;
    const { showEditProjectModal, isNewProject, fetching } = this.props;
    const closeBtn = (
      <button className="close" onClick={this.handleClick_cancel}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditProjectModal}
          toggle={this.handleClick_cancel}
          className={this.props.className}
          size={"xl"}
          fade={false}
        >
          <ModalHeader
            toggle={this.handleClick_cancel}
            className="bg-info text-white"
            close={closeBtn}
          >
            {isNewProject ? (
              <FontAwesomeIcon icon="folder-plus" className="fa-fw mr-2" />
            ) : (
              <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
            )}
            {isNewProject ? "Add New Project" : "Edit Project Info"}
          </ModalHeader>
          <ModalBody>
            <form name="addNewProject">
              <div className="card m-2">
                <div className="card-body">
                  <div className="row pb-2">
                    <h4 className="ml-2">Basic Project Information</h4>
                  </div>
                  <h5 className="text-muted mx-0 mb-0">EA, EFIS, Fed ID</h5>
                  <hr className="mt-1 mb-2" />
                  <div className="form-row">
                    <div className="form-group col-md-2">
                      <label htmlFor="district" className="mb-1">
                        <b>District:</b>*
                      </label>
                      <Select
                        name="district"
                        id="district"
                        isSearchable={false}
                        value={formData.selectedDistrict}
                        options={this.projDistOptions}
                        onChange={this.handleChange_select(
                          "district",
                          "selectedDistrict"
                        )}
                        onBlur={this.handleBlur_select("district")}
                      />
                      {formErrors.district && (
                        <span className="error-small">
                          <small>{formErrors.district}</small>
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-2">
                      <label htmlFor="ea" className="mb-1">
                        <b>EA:</b>* <small>6-digit EA</small>
                      </label>
                      <input
                        type="text"
                        name="ea"
                        id="ea"
                        maxLength="6"
                        className="form-control"
                        value={formData.ea || ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                      {formErrors.ea && (
                        <span className="error-small">
                          <small>{formErrors.ea}</small>
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="eFis" className="mb-1">
                        EFIS Project ID:
                      </label>
                      <input
                        type="text"
                        name="efis"
                        id="efis"
                        className="form-control"
                        maxLength="10"
                        value={formData.efis || ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                    <div className="form-group col-md-5">
                      <label htmlFor="fedId" className="mb-1">
                        Federal Aid No(s):
                        <small className="ml-1">Separate by commas for multiple.</small>
                      </label>
                      <input
                        type="text"
                        name="fedId"
                        id="fedId"
                        className="form-control"
                        value={formData.fedId || ""}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <h5 className="text-muted mx-0 mb-0 mt-2">County-Route-PM</h5>
                  <hr className="mt-1 mb-2" />
                  <div className="form-row mb-1">
                    <div className="form-group col-md-4 mb-0">
                      <label htmlFor="county1" className="mb-0">
                        <b>County 1:</b>*
                      </label>
                      <Select
                        name="county1"
                        id="county1"
                        value={formData.selectedCounty1}
                        options={this.countyOptions}
                        onChange={this.handleChange_select("county1", "selectedCounty1")}
                        onBlur={this.handleBlur_select("selectedCounty1")}
                        isClearable
                      />
                      {formErrors.county1 && (
                        <span className="error-small">
                          <small>{formErrors.county1}</small>
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="route1" className="mb-0">
                        <b>Route 1:</b>*
                      </label>
                      <input
                        type="text"
                        name="route1"
                        id="route1"
                        className="form-control"
                        value={formData.route1 || ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                      {formErrors.route1 && (
                        <span className="error-small">
                          <small>{formErrors.route1}</small>
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="backPostMile1" className="mb-0">
                        <b>Back PM 1:</b>*
                      </label>
                      <input
                        type="text"
                        name="backPostMile1"
                        id="backPostMile1"
                        className="form-control"
                        value={formData.backPostMile1 ?? ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                      {formErrors.backPostMile1 && (
                        <span className="error-small">
                          <small>{formErrors.backPostMile1}</small>
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="aheadPostMile1" className="mb-0">
                        <b>Ahead PM 1:</b>*
                      </label>
                      <input
                        type="text"
                        name="aheadPostMile1"
                        id="aheadPostMile1"
                        className="form-control"
                        value={formData.aheadPostMile1 ?? ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                      {formErrors.aheadPostMile1 && (
                        <span className="error-small">
                          <small>{formErrors.aheadPostMile1}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row mb-1">
                    <div className="form-group col-md-4 mb-0">
                      <label htmlFor="county2" className="mb-0">
                        County 2:
                      </label>
                      <Select
                        name="county2"
                        id="county2"
                        value={formData.selectedCounty2}
                        options={this.countyOptions}
                        onChange={this.handleChange_select("county2", "selectedCounty2")}
                        onBlur={this.handleBlur_select("selectedCounty2")}
                        isClearable
                      />
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="route2" className="mb-0">
                        Route 2:
                      </label>
                      <input
                        type="text"
                        name="route2"
                        id="route2"
                        className="form-control"
                        value={formData.route2 || ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="backPostMile2" className="mb-0">
                        Back PM 2:
                      </label>
                      <input
                        type="text"
                        name="backPostMile2"
                        id="backPostMile2"
                        className="form-control"
                        value={formData.backPostMile2 ?? ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="aheadPostMile2" className="mb-0">
                        Ahead PM 2:
                      </label>
                      <input
                        type="text"
                        name="aheadPostMile2"
                        id="aheadPostMile2"
                        className="form-control"
                        value={formData.aheadPostMile2 ?? ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                  </div>
                  <div className="form-row mb-1">
                    <div className="form-group col-md-4 mb-0">
                      <label htmlFor="county3" className="mb-0">
                        County 3:
                      </label>
                      <Select
                        name="county3"
                        id="county3"
                        value={formData.selectedCounty3 || ""}
                        options={this.countyOptions}
                        onChange={this.handleChange_select("county3", "selectedCounty3")}
                        onBlur={this.handleBlur_select("selectedCounty3")}
                        isClearable
                      />
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="route3" className="mb-0">
                        Route 3:
                      </label>
                      <input
                        type="text"
                        name="route3"
                        id="route3"
                        className="form-control"
                        value={formData.route3 || ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="backPostMile3" className="mb-0">
                        Back PM 3:
                      </label>
                      <input
                        type="text"
                        name="backPostMile3"
                        id="backPostMile3"
                        className="form-control"
                        value={formData.backPostMile3 ?? ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="aheadPostMile3" className="mb-0">
                        Ahead PM 3:
                      </label>
                      <input
                        type="text"
                        name="aheadPostMile3"
                        id="aheadPostMile3"
                        className="form-control"
                        value={formData.aheadPostMile3 ?? ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                  </div>
                  <div className="form-row mb-2">
                    <div className="form-group col-md-4 mb-0">
                      <label htmlFor="county4" className="mb-0">
                        County 2:
                      </label>
                      <Select
                        name="county4"
                        id="county4"
                        value={formData.selectedCounty4}
                        options={this.countyOptions}
                        onChange={this.handleChange_select("county4", "selectedCounty4")}
                        onBlur={this.handleBlur_select("selectedCounty2")}
                        isClearable
                      />
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="route4" className="mb-0">
                        Route 4:
                      </label>
                      <input
                        type="text"
                        name="route4"
                        id="route4"
                        className="form-control"
                        value={formData.route4 || ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="backPostMile4" className="mb-0">
                        Back PM 4:
                      </label>
                      <input
                        type="text"
                        name="backPostMile4"
                        id="backPostMile4"
                        className="form-control"
                        value={formData.backPostMile4 ?? ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                    <div className="form-group col-md-2 mb-0">
                      <label htmlFor="aheadPostMile4" className="mb-0">
                        Ahead PM 4:
                      </label>
                      <input
                        type="text"
                        name="aheadPostMile4"
                        id="aheadPostMile4"
                        className="form-control"
                        value={formData.aheadPostMile4 ?? ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                  </div>
                  <h5 className="text-muted mx-0 mb-0 mt-3">
                    Work and Location Descriptions
                  </h5>
                  <hr className="mt-1 mb-2" />
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label htmlFor="workDescription" className="mb-1">
                        <b>Work Description:</b>* <small>i.e. Widen Freeway</small>
                      </label>
                      <input
                        type="text"
                        name="workDescription"
                        id="workDescription"
                        className="form-control"
                        value={formData.workDescription || ""}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                      />
                      {formErrors.workDescription && (
                        <span className="error-small">
                          <small>{formErrors.workDescription}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label htmlFor="locationDescription" className="mb-1">
                        Location Description:
                        <small className="ml-1">
                          i.e. Construction on State Highway in Marin County, ...
                        </small>
                      </label>
                      <textarea
                        rows="2"
                        name="locationDescription"
                        id="locationDescription"
                        className="form-control"
                        value={formData.locationDescription || ""}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card m-2">
                <div className="card-body">
                  <div className="row pb-2">
                    <h4 className="ml-2">Other Details</h4>
                  </div>
                  <h5 className="text-muted mx-0 mb-0">Working Days</h5>
                  <hr className="mt-1 mb-2" />
                  <div className="form-row">
                    <div className="form-group col-sm-2">
                      <label htmlFor="calendarType" className="mb-1">
                        WD Type:
                      </label>
                      <Select
                        name="calendarType"
                        id="calendarType"
                        isSearchable={false}
                        value={formData.selectedCalendarType}
                        options={this.calendarTypes}
                        onChange={this.handleChange_select(
                          "calendarType",
                          "selectedCalendarType"
                        )}
                        onBlur={this.handleBlur_select("selectedCalendarType")}
                      />
                    </div>
                    <div className="form-group col-sm-3">
                      <label htmlFor="workingDays" className="mb-1">
                        Working Days:
                      </label>
                      <div className="input-group">
                        <input
                          type="number"
                          name="workingDays"
                          id="workingDays"
                          className="form-control"
                          value={formData.workingDays || 0}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">Days</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 className="text-muted mx-0 mb-0 mt-2">Milestone Dates</h5>
                  <hr className="mt-1 mb-2" />
                  <div className="form-row">
                    <div className="form-group col-sm-3">
                      <label htmlFor="bidOpeningDate" className="mb-1">
                        Bid Opening:
                      </label>
                      <DatePicker
                        customInput={<CustomDatePickerInput />}
                        name="bidOpeningDate"
                        id="bidOpeningDate"
                        className="form-control"
                        selected={formData.bidOpeningDate}
                        onChange={this.handleChange_dateFields("bidOpeningDate")}
                      />
                    </div>
                    <div className="form-group col-sm-3">
                      <label htmlFor="awardDate" className="mb-1">
                        Award:
                      </label>
                      <DatePicker
                        customInput={<CustomDatePickerInput />}
                        name="contractAwardDate"
                        id="contractAwardDate"
                        className="form-control"
                        selected={formData.contractAwardDate}
                        onChange={this.handleChange_dateFields("contractAwardDate")}
                      />
                    </div>
                    <div className="form-group col-sm-3">
                      <label htmlFor="approvalDate" className="mb-1">
                        Approval:
                      </label>
                      <DatePicker
                        customInput={<CustomDatePickerInput />}
                        name="contractApprovalDate"
                        id="approvacontractApprovalDatelDate"
                        className="form-control"
                        selected={formData.contractApprovalDate}
                        onChange={this.handleChange_dateFields("contractApprovalDate")}
                      />
                    </div>
                    <div className="form-group col-sm-3">
                      <label htmlFor="workStartDate" className="mb-1">
                        1st WD:
                      </label>
                      <DatePicker
                        customInput={<CustomDatePickerInput />}
                        name="firstWorkingDay"
                        id="firstWorkingDay"
                        className="form-control"
                        selected={formData.firstWorkingDay}
                        onChange={this.handleChange_dateFields("firstWorkingDay")}
                      />
                    </div>
                  </div>
                  <h5 className="text-muted mx-0 mb-0 mt-2">Cost and Markups</h5>
                  <hr className="mt-1 mb-2" />
                  <div className="form-row">
                    <div className="form-group col-sm-6">
                      <label htmlFor="engineersEstimate" className="mb-1">
                        Engineers Estimate:
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">$</span>
                        </div>
                        <input
                          type="number"
                          name="engineersEstimate"
                          id="engineersEstimate"
                          className="form-control"
                          value={formData.engineersEstimate || 0}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-row mb-2">
                    <div className="form-check-inline custom-control custom-checkbox my-auto ml-1">
                      <input
                        type="checkbox"
                        name="useTroMarkup"
                        id="useTroMarkup"
                        className="custom-control-input"
                        checked={formData.useTroMarkup}
                        onChange={this.handleChange_check}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="hasSupervisingUnit"
                      >
                        Use TRO Markup
                      </label>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-3 mb-0">
                      <label htmlFor="primeLaborMarkup" className="mb-0">
                        Prime Labor Markup:
                      </label>
                      <div className="input-group">
                        <input
                          type="number"
                          name="primeLaborMarkup"
                          id="primeLaborMarkup"
                          className="form-control"
                          style={{ textAlign: "right" }}
                          value={formData.primeLaborMarkup || ""}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">%</span>
                        </div>
                      </div>
                      {formErrors.primeLaborMarkup && (
                        <span className="error-small">
                          <small>{formErrors.primeLaborMarkup}</small>
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-3 mb-0">
                      <label htmlFor="primeEquipmentMarkup" className="mb-0">
                        Prime Equipment Markup:
                      </label>
                      <div className="input-group">
                        <input
                          type="number"
                          name="primeEquipmentMarkup"
                          id="primeEquipmentMarkup"
                          className="form-control"
                          style={{ textAlign: "right" }}
                          value={formData.primeEquipmentMarkup || ""}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">%</span>
                        </div>
                      </div>
                      {formErrors.primeEquipmentMarkup && (
                        <span className="error-small">
                          <small>{formErrors.primeEquipmentMarkup}</small>
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-3 mb-0">
                      <label htmlFor="primeMaterialMarkup" className="mb-0">
                        Prime Mat'l Markup:
                      </label>
                      <div className="input-group">
                        <input
                          type="number"
                          name="primeMaterialMarkup"
                          id="primeMaterialMarkup"
                          className="form-control"
                          style={{ textAlign: "right" }}
                          value={formData.primeMaterialMarkup || ""}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">%</span>
                        </div>
                      </div>
                      {formErrors.primeMaterialMarkup && (
                        <span className="error-small">
                          <small>{formErrors.primeMaterialMarkup}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-3 mb-0">
                      <label htmlFor="subcontractorMarkup" className="mb-0">
                        Sub Markup:
                      </label>
                      <div className="input-group">
                        <input
                          type="number"
                          name="subcontractorMarkup"
                          id="subcontractorMarkup"
                          className="form-control"
                          style={{ textAlign: "right" }}
                          value={formData.subcontractorMarkup || ""}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">%</span>
                        </div>
                      </div>
                      {formErrors.subcontractorMarkup && (
                        <span className="error-small">
                          <small>{formErrors.subcontractorMarkup}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-3 mb-0">
                      <label htmlFor="subLaborMarkup" className="mb-0">
                        Sub Labor Markup:
                      </label>
                      <div className="input-group">
                        <input
                          type="number"
                          name="subLaborMarkup"
                          id="subLaborMarkup"
                          className="form-control"
                          style={{ textAlign: "right" }}
                          value={formData.subLaborMarkup || ""}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">%</span>
                        </div>
                      </div>
                      {formErrors.subLaborMarkup && (
                        <span className="error-small">
                          <small>{formErrors.subLaborMarkup}</small>
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-3 mb-0">
                      <label htmlFor="subEquipmentMarkup" className="mb-0">
                        Sub Equipment Markup:
                      </label>
                      <div className="input-group">
                        <input
                          type="number"
                          name="subEquipmentMarkup"
                          id="subEquipmentMarkup"
                          className="form-control"
                          style={{ textAlign: "right" }}
                          value={formData.subEquipmentMarkup || ""}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">%</span>
                        </div>
                      </div>
                      {formErrors.subEquipmentMarkup && (
                        <span className="error-small">
                          <small>{formErrors.subEquipmentMarkup}</small>
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-3 mb-0">
                      <label htmlFor="subMaterialMarkup" className="mb-0">
                        Sub Mat'l Markup:
                      </label>
                      <div className="input-group">
                        <input
                          type="number"
                          name="subMaterialMarkup"
                          id="subMaterialMarkup"
                          className="form-control"
                          style={{ textAlign: "right" }}
                          value={formData.subMaterialMarkup || ""}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">%</span>
                        </div>
                      </div>
                      {formErrors.subMaterialMarkup && (
                        <span className="error-small">
                          <small>{formErrors.subMaterialMarkup}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  {/* <div className="form-group col-sm-3">
                      <label htmlFor="projectStatus" className="mb-1">
                        Current Status:
                      </label>
                      <Select
                        name="projectStatus"
                        id="projectStatus"
                        isSearchable={false}
                        value={formData.selectedProjectStatus}
                        options={this.projStatusOptions}
                        onChange={this.handleChange_select(
                          "projectStatus",
                          "selectedProjectStatus"
                        )}
                        onBlur={this.handleBlur_select("projectStatus")}
                      />
                    </div> */}
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group float-right mr-2 mb-0">
              {fetching && (
                <span>
                  <small>Saving...</small>
                </span>
              )}
              <button
                type="submit"
                name="submitEditProjectForm"
                id="submitEditProjectForm"
                className="btn btn-primary mx-2"
                onClick={this.handleSubmit}
                disabled={this.formIsIncomplete() || fetching}
              >
                {isNewProject ? "Add Project" : "Save"}
              </button>
              <button
                type="button"
                name="cancelEditProject"
                id="cancelEditProject"
                className="btn btn-secondary"
                onClick={this.handleClick_cancel}
                disabled={fetching}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
        {showAlert_editSuccess && (
          <AlertModal
            alertKey={"saveProjSuccessfulAlertKey"}
            alertTitle="Save Successful"
            alertTitleClass="bg-success text-white"
            alertTitleIcon="check"
            alertText={"Project information saved successfully."}
            acceptCaption="OK"
            acceptClass="primary"
            provideReject={false}
            handleAlertAction={this.handleAlert_addSuccess}
            showAlertModal={showAlert_editSuccess}
            toggleAlertModal={this.toggleAlert_editSuccess}
          />
        )}
        {showAlert_cancel && (
          <AlertModal
            alertKey={"cancelEditProjAlertKey"}
            alertTitle={isNewProject ? "Cancel Add Project" : "Cancel Edit Project"}
            alertTitleClass="bg-warning"
            alertTitleIcon="exclamation-triangle"
            alertText="Are you sure you want to cancel?"
            acceptCaption={"Yes"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_cancel}
            showAlertModal={showAlert_cancel}
            toggleAlertModal={this.toggleAlert_cancel}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  project: state.projects.openProjectDetails[ownProps.projectId] || null,
  authentication: state.authentication,
  fetching: state.projects.fetching,
});

export default connect(mapStateToProps)(EditProjectModal);
